<template>
  <div class="flex flex-col mb-4">
    <strong class="mb-1">{{ label }}</strong>
    <input
      :dusk="`${label}-input`"
      :value="value"
      @input="$emit('input', $event.target.value)"
      :type="type"
      :placeholder="label"
      :class="['input input-bordered', { 'input-error': error }]"
    />
    <p class="text-red-500 text-xs mt-1">{{ error }}</p>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: false,
      default: 'text',
    },
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    error: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>

<style scoped>
.input {
  width: 100%;
}
</style>
